export default __webpack_public_path__ + "static/media/guard.74aa9c64.svg";